// extracted by mini-css-extract-plugin
export var assigneeBadge = "_ja-0";
export var assigneeDetails = "_ja-1";
export var assigneeInfo = "_ja-2";
export var dropdownContainer = "_ja-4";
export var dropdownImage = "_ja-5";
export var editAssigneeInfo = "_ja-3";
export var editAssigneeModalContainer = "_ja-6";
export var hidden = "_ja-8";
export var input = "_ja-7";